import React, { Component } from "react";
import moment from 'moment';
import HostControls from "./HostControls";
import ParticipantStreams from "./ParticipantStreams";
import InstructorTutorial from "./InstructorTutorial";
import HostStreaming from "../../streaming/HostStreaming";
import PlaylistContent from "./PlaylistContent";
import HostStream from "./HostStream";
import HostFitnessScript from "./HostFitnessScript"; 
import ActivityMenu from "./ActivityMenu";
import ActivityVideo from "./ActivityVideo";
import ChatContainer from "./ChatContainer";
import ZoomedHost from "./ZoomedHost";
import CompleteSession from "./CompleteSession";
import SupportContainer from '../home/SupportContainer';
import ParticipantsList from "./ParticipantsList";

class InstructorEnterprise extends Component {
  
  constructor(props) {
		super(props);
		this.state={
		}
	}
 
	componentDidMount(){
	
	}
	
	render() {
		const pThis = this.props.mainthis;
	
		return (
			<>
				<div className={"host_stream_container " + ( pThis.state.rightMenuOpen ? "container_right_menu" : "" ) }>
					<div className="host_header">
						<div className="session_data_container session_data_container_host menu_hidden_item">
							{pThis.state.sessionData.channelImage != 'default.png' ?
								<div className="channelimg" style={{backgroundImage: "url('" + pThis.state.sessionData.channelImage + "')"}}></div>
								:
								<div className="channelimg defChannelImg"></div>
							}
							<div className="sess_name">{pThis.state.sessionData.name}</div>
							<div className="host_container">By {pThis.state.sessionData.hostFirstName} {pThis.state.sessionData.hostLastName}</div>
							<div className="online_icon"></div>
							<div className="online_text">ONLINE</div>
						</div>
						<HostControls 
						state={pThis.state}
						updateStateFromChild={pThis.updateStateFromChild} 
						chatOpen={pThis.state.chatOpen}
						nextTutorial={pThis.nextTutorial}
						backTutorial={pThis.backTutorial}>
						</HostControls>
						<div className="recording_on d-none" id="recordingon">
							<div className="rec_icon"></div>
							<div className="rec_text">Recording to the cloud</div>
						</div>
						<div className="marq align-self-end flex-grow-1"><div className="particlecontainer-host"></div></div>
					</div>
					<div className="participant_view_container">
						<div className="left_view">
							<div className="participants_title">Members (<div className="numDisplay" id="currentOnScreenNum">0</div>/<div className="numDisplay" id="maxOnScreenNum">{pThis.state.signedUpUsers}</div>)</div>
							{ ( pThis.state.signedUpUsers > 0 || pThis.state.tutorialMessNum == 2 ) &&
								<div className="viewall_part" onClick={(e)=>{pThis.showParticipantList(1)}} id="view_all_participants">View all</div>
							}
							<div className="audienceRaiseHand audienceCircle d-none" onClick={(e)=>{pThis.showRaisedList(e)}} >
								<div className="audienceHolder d-none" >
									 <div className="border_h1" >
										 <div className="raised_hands_h1" > Raised Hands ({pThis.state.audienceRaisedList.length}) </div>
										 <div className="close_audienceList" onClick={(e)=>{pThis.closeRaisedList(e)}} ></div>
									 </div>
									 { pThis.state.audienceRaisedList && pThis.state.audienceRaisedList.length > 0 &&
										 <div className="all_audience_hold" >
											 {pThis.state.audienceRaisedList.map((opt, i) =>
												<div className="singleHolder" key={i} userDetails-id={opt.id}  >
													<div className="audience_image" style={{backgroundImage: "url('" + opt.image + "')"}} ></div>
													<div className="hold_audience_name" >	
														<div className="audience_name" >{opt.firstName} {opt.lastName}</div>
														<div className="audience_time" >{moment(opt.raisedTime).fromNow()}</div>
													</div>
												</div>
											 )}
										</div>
									}
								</div>
							</div>
							{pThis.state.tutorialMessNum == 2 &&
								<InstructorTutorial
								nextTutorial={pThis.nextTutorial}
								backTutorial={pThis.backTutorial}
								finishTutorial={pThis.finishTutorial}
								state={pThis.state}>
								</InstructorTutorial>
							}
						</div>
						<div className="right_view">
							<div className="onscreen_title">On Screen:</div>
							<select onChange={(e) => pThis.setOnScreen(e)} className="onscreen_select" id="maxuserlimit" >
								<option value="0">0</option>
							</select>
						</div>
					</div>
					<div id="actStart" className="screen_popup p-4 bg-grayy rounded white_hdng actStartHost d-none"></div>
					<div className="col-6 col-md-6 align-items-center paletteFlex d-none">
						<div className="closePalette" onClick={(e)=>{pThis.closePalette(e)}} ></div>
					</div>
					<ParticipantStreams
						state={pThis.state}
						startSession={pThis.startSession}
						showParticipantList={pThis.showParticipantList}
						nextTutorial={pThis.nextTutorial}
						backTutorial={pThis.backTutorial}
						finishTutorial={pThis.finishTutorial}
						startSessionInfo={pThis.startSessionInfo}
						canStartSessionRTM={pThis.state.canStartSessionRTM} 
						autoShowedMessage={pThis.state.autoShowedMessage}
					></ParticipantStreams>
					<div className="footer_host">
						<div className="footerPartHolder" >
							<HostStream></HostStream>
						</div>
						<div className="footerPartHolder scriptHoldWidth" >
							<div className="min_script_holder" >
								<HostFitnessScript 
									state={pThis.state} 
									updateStateFromChild={pThis.updateStateFromChild}
									nextTutorial={pThis.nextTutorial}
									backTutorial={pThis.backTutorial}>
								</HostFitnessScript>
								<PlaylistContent></PlaylistContent>
							</div>
						</div>
						<div className="for_powered_by">
							<div className="powered_streaming"></div>
							<div className="footer_logo"></div>
						</div>
					</div>
				</div>
				
				<div id="chat_menu" className={(!pThis.state.chatOpen ? "d-none" : "chat_container" )}>
					<ChatContainer updateStateFromChild={pThis.updateStateFromChild}></ChatContainer>
				</div>
				
				<div className={(!pThis.state.activityListOpen ? "d-none" : "left_container" )}>
					<ActivityMenu 
					state={pThis.state}
					updateStateFromChild={pThis.updateStateFromChild} 
					playActivityVideo={pThis.playActivityVideo}>
					</ActivityMenu>
				</div>
				
				<ZoomedHost></ZoomedHost>
				{ pThis.state.openLeave &&
					<CompleteSession updateStateFromChild={pThis.updateStateFromChild} sessionName={pThis.state.sessionData.name}></CompleteSession>
				}
				
				<SupportContainer supportPageName={pThis.state.supportPageName} supportPageApi={pThis.state.supportPageApi} userTypeFaqs={pThis.state.userTypeFaqs}></SupportContainer>
			
				{ pThis.state.openActivityVideo &&
					<ActivityVideo videoURL={pThis.state.videoURL} updateStateFromChild={pThis.updateStateFromChild}></ActivityVideo>
				}
				
				<div className="holdPartList d-none" id="memebrsList">
					<ParticipantsList
						state={pThis.state}
						showParticipantList={pThis.showParticipantList}
						ejectParticipant={pThis.ejectParticipant}
						updateStateFromChild={pThis.updateStateFromChild}
					></ParticipantsList>
				</div>
				
				
			</>
	)}
}
export default InstructorEnterprise;
